module.exports = __webpack_public_path__ + "img/1550476262.2fdf9666.jpg";